import firebase from 'firebase';
import { parseName } from 'humanparser';
import { AuthUser } from 'types/User';

export default function extractDataFromFirebaseCredentials(
  credential: firebase.auth.UserCredential
): AuthUser {
  const userInfo = credential.user;

  if (!userInfo) {
    throw new Error('no user info');
  }

  const profileInfo: {
    // eslint-disable-next-line camelcase
    first_name?: string;
    // eslint-disable-next-line camelcase
    last_name?: string;
    name?: string;
  } = credential?.additionalUserInfo?.profile || {};
  let firstName;
  let lastName;

  if (profileInfo.name || profileInfo.first_name || profileInfo.last_name) {
    const parsed = parseName(profileInfo.name || '');
    firstName = parsed.firstName || profileInfo.first_name;
    lastName = parsed.lastName || profileInfo.last_name;
  }

  return {
    firstName,
    lastName,
    firebaseUid: userInfo.uid,
    email: userInfo.email as string,
  };
}
